module.exports = __webpack_public_path__ + "img/item3.8a9448fb.png";